import { SettingsDto } from '../context/GlobalContext'
import useGlobalContext from './useGlobalContext'

export type SettingsReturnProps = {
    loaded: boolean
    settings: SettingsDto
}

export function useSettings(): SettingsReturnProps {
    const { loaded, entities } = useGlobalContext('settings')

    return { loaded, settings: entities }
}
